import script from "./Exam.vue?vue&type=script&setup=true&lang=js"
export * from "./Exam.vue?vue&type=script&setup=true&lang=js"

export default script